<template>
	<div class="baground">
		<img class="logo" v-if="name.startsWith('http')" :src="name" />
		<h1 class="logo" v-else>{{ name }}</h1>
		<b-alert show variant="danger" v-if="errorMsg">{{errorMsg}}</b-alert>
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";

	export default {
		name: "login_sso",
		data() {
			return {
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || "Smartmydata",
			};
		},
		methods: {
			login_sso(token) {
				//token = "eyJhbGciOiAiSFM1MTIiLCJ0eXAiOiAiSldUIn0=.ew0KCQkJImlhdCI6ICIxNjYxNDE4MTM1IiwNCgkJCSJpc3MiOiAiR0NSIiwNCgkJCSJhdWQiOiAiaHR0cHM6Ly9leHRyYW5ldC5hc2ZvcnRlcy5mciIsDQoJCQkic3ViIjogIjM0MTY5IiwNCgkJCSJmaXJzdF9uYW1lIjogIkRBVklEIiwNCgkJCSJsYXN0X25hbWUiOiAiQkFZTyIsDQoJCQkiZW1haWwiOiAic29jaWFsLmF2aWdub25AZ3JvdXBlLW1hdXJpbi5jb20iLA0KCQkJImVudGl0aWVzIjogIk40Mzg3MnxONDM4NzN8TjQzODc0fE40Mzg3NSIsDQoJCQkiZG9tYWluZSI6ICJSZXNzb3VyY2VzIGh1bWFpbmVzIiwNCgkJCSJmb25jdGlvbiI6ICJEUkggLyBBZGpvaW50Ig0KCQl9.fYKer7jFT6N8cHIa8C/7KmYjKTZfgM73hJgd+IpT0oJqRM3nhDZ01V3YFaLtxNPRQvIjBhQKL5dtUHPmwfjlCw=="
				console.log(token)
				login
					.authSSO(token)
					.then(async (res) => {
						let jwt = res.data.jwt;
						this.$store.commit("setJwt", jwt);

						var response = await users.getSelf(true);
						this.$store.commit("setUser", response.user);						

						this.$emit("loginSuccess");
						this.$router.push({ name: "main" });
					})
					.catch((err) => {
						console.error(err.response.data.msg)
						this.error = true;
						this.errorMsg =
							err.response.data.msg
					});
			},
		},
		mounted() {
			this.login_sso(this.$route.query.token)
		}
	};
</script>

<style>
	.baground {
		margin-right: 250px;
	}
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
